export default "__VITE_ASSET__Caz6YrOx__"